export const eid_activation_2026video0 = '/eid_activation_2026/SHOWREEL.mp4';

export const newsPosts = [
  {
    id: 'eid_activation_2026',
    date: '2026-05-29',
    cover: '/images/campaign-eid.jpg',
    title: {
      en: 'Fly High Brothers" Helicopter Showers Worshippers with Gifts on the First Day of Eid Al-Adha',
      ar: 'طائرة "Fly High Brothers" تمطر المصلين بالهدايا في أول أيام عيد الأضحى',
    },
    description: {
      en: 'Fly High Brothers executed a helicopter flight on the first day of Eid Al-Adha during the Eid prayer, dropping gifts via parachutes onto the worshippers in one of the biggest promotional and entertainment events of the year. The idea and execution were entirely carried out by Fly High Brothers. This event is considered one of the first innovative concepts of its kind globally in the field of interactive aerial advertising. Sponsored by: Dubai Real Estate Company Al Oula Real Estate Company Special thanks and appreciation go to the Fly High team, as well as the director and artist Hany Amer, Jana Ahmed, and Henry Abdelmessih.',
      ar: 'شركة Fly High Brothers نفذت طلعة جوية بطائرة هليكوبتر في أول أيام عيد الأضحى أثناء صلاة العيد وقامت بإلقاء الهدايا بالبراشوت على المصلين في واحدة من أكبر الفعاليات الدعائية والترفيهية هذا العام الفكرة والتنفيذ بالكامل بواسطة Fly High Brothers ويعد هذا الحدث من أول الأفكار المبتكرة من نوعها على مستوى العالم في مجال الدعاية الجوية التفاعلية برعاية شركة دبي العقارية وشركة الأولى العقارية و كل الشكر و التقدير لفريق عمل فلاي هاي و المخرج و الفنان هاني عامر  و جنا احمد و هنري عبد المسيح',
    },
    media: [
      { type: 'image', src: '/images/campaign-eid.jpg' },
      { type: 'video', src: '/eid_activation_2026/SHOWREEL.mp4' },
    ],
  },
  // {
  //   id: 'stadium-banner-2025',
  //   date: '2025-11-08',
  //   cover: '/images/campaign-stadium.jpg',
  //   title: {
  //     en: 'Stadium Banner — 80,000 Capacity',
  //     ar: 'لافتة الملعب — 80,000 مقعد',
  //   },
  //   description: {
  //     en: 'A massive aerial banner activation above one of Egypt\'s largest stadiums, delivering 100% viewability to a live crowd of 80,000+ spectators.',
  //     ar: 'تفعيل لافتة جوية ضخمة فوق أحد أكبر ملاعب مصر، مع قابلية رؤية 100% لحشد مباشر يتجاوز 80,000 متفرج.',
  //   },
  //   media: [
  //     { type: 'image', src: '/images/campaign-stadium.jpg' },
  //     { type: 'image', src: '/images/aerial-banner-dragging.jpg' },
  //     { type: 'image', src: '/images/service-aerial.jpg' },
  //   ],
  // },
  // {
  //   id: 'north-coast-launch',
  //   date: '2025-08-15',
  //   cover: '/images/campaign-north-coast.jpg',
  //   title: {
  //     en: 'Brand Launch — North Coast',
  //     ar: 'إطلاق علامة — الساحل الشمالي',
  //   },
  //   description: {
  //     en: 'Premium brand launch activation along Egypt\'s North Coast, combining aerial banner dragging with cinematic content capture for digital amplification.',
  //     ar: 'تفعيل إطلاق علامة متميز على الساحل الشمالي، يجمع بين سحب اللافتات الجوية والتصوير السينمائي للتضخيم الرقمي.',
  //   },
  //   media: [
  //     { type: 'image', src: '/images/campaign-north-coast.jpg' },
  //   ],
  // },
  // {
  //   id: 'showreel-2025',
  //   date: '2025-06-01',
  //   cover: '/images/hero-aerial.jpg',
  //   title: {
  //     en: 'FlyHigh Brothers Showreel 2025',
  //     ar: 'العرض التقديمي لـ FlyHigh Brothers 2025',
  //   },
  //   description: {
  //     en: 'Watch our latest showreel showcasing aerial advertising, media production, and brand activations across Egypt.',
  //     ar: 'شاهد أحدث عرض تقديمي يعرض الإعلان الجوي والإنتاج الإعلامي وتفعيلات العلامات في مصر.',
  //   },
  //   media: [
  //     { type: 'video', src: SHOWREEL_VIDEO },
  //     { type: 'image', src: '/images/hero-aerial.jpg' },
  //   ],
  // },
];
